export default __webpack_public_path__ + "9290f45c8a0d31af715be55903347c87.svg";